export const CreditCardRouteName = Object.freeze({
  CreditCard: 'credit-card'
})
